module.exports = __webpack_public_path__ + "media/images/top/works06-4f83a3453f4ca0e29394dcef3026838c.jpg";